import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/SegmentsTable.vue"),
          meta: { title: "Список сегментов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/SegmentsForm.vue"),
          meta: { title: "Создать сегмент", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/SegmentsForm.vue"),
          meta: { title: "Редактировать сегмент", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
